
import { LOCAL_STORAGE_APP_KEY } from '../constants';
// From notes on Dan Abramov Article
//https://medium.com/@jrcreencia/persisting-redux-state-to-local-storage-f81eb0b90e7e

// Remember not to trust wild input
// https://blog.acolyer.org/2019/04/10/dont-trust-the-locals-investigating-the-prevalence-of-persistent-client-side-cross-site-scripting-in-the-wild/
export const loadState = () => {
  try {
    const serializedState = localStorage.getItem(LOCAL_STORAGE_APP_KEY);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(LOCAL_STORAGE_APP_KEY, serializedState);
  } catch {
    // ignore write errors, for privacy or serializing non string reasons
  }
};
